import { render, staticRenderFns } from "./Mainbox.vue?vue&type=template&id=6cebd9f3&scoped=true"
import script from "./Mainbox.vue?vue&type=script&lang=js"
export * from "./Mainbox.vue?vue&type=script&lang=js"
import style0 from "./Mainbox.vue?vue&type=style&index=0&id=6cebd9f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cebd9f3",
  null
  
)

export default component.exports